"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonField = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var ButtonField = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var buttonData = _a.buttonData;
    var color = ((_b = buttonData.style) === null || _b === void 0 ? void 0 : _b.color) ? buttonData.style.color : "white";
    if ((_c = buttonData.style) === null || _c === void 0 ? void 0 : _c.backgroundColor)
        delete buttonData.style.backgroundColor;
    if ((_d = buttonData.style) === null || _d === void 0 ? void 0 : _d.color)
        delete buttonData.style.color;
    return (react_2.default.createElement(react_1.Box, { width: "100%", className: "" + (buttonData.class ? buttonData.class : ""), textAlign: "center" },
        react_2.default.createElement(react_1.Button, { css: buttonData.style, href: buttonData.data.link, target: ((_e = buttonData.data) === null || _e === void 0 ? void 0 : _e.target) ? buttonData.data.target : undefined, rel: ((_f = buttonData.data) === null || _f === void 0 ? void 0 : _f.target) ? "noopener noreferrer" : undefined, mx: "auto", width: "100%", as: "a", type: "button", color: color, size: "lg", height: "auto", fontSize: "1.6rem", paddingY: "5", whiteSpace: "normal", _hover: {
                color: color,
                backgroundColor: (_h = (_g = buttonData.style) === null || _g === void 0 ? void 0 : _g.backgroundColor) !== null && _h !== void 0 ? _h : "",
                textDecoration: "none",
                opacity: 0.7,
            }, _active: {
                color: color,
                backgroundColor: (_k = (_j = buttonData.style) === null || _j === void 0 ? void 0 : _j.backgroundColor) !== null && _k !== void 0 ? _k : "",
                opacity: 0.7,
            } }, buttonData.data.body)));
};
exports.ButtonField = ButtonField;
